// @ts-check
import { LitElement, html, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { ProgressModel } from '../../../src/models/progress-model';
import { UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import "@maersk-global/mds-components-core";


export class VoyageLoadingIndicator extends LitElement {
    constructor() {
        super();

        this.refreshDisplayState = this.refreshDisplayState.bind(this);

        this.isDisplayed = false;
    }

    static get properties() {
        return {
            isDisplayed: { type: Boolean }
        };
    }

    static get styles() {
        return css`
            .loading-indicator {
                padding: 4px;
                background-color: rgba(0,0,0,0.5);
                color: white;
                font-family: var(--component-heading-ff, 'serif');
                font-size: var(--component-heading-size, 20px);
                line-height: var(--component-heading-height, 20px);
                font-weight: var(--component-heading-weight, normal);
            }
            .spinner{
                position: fixed;
                left: 50%;
                top: 50px;
                background-color: rgba(255,255,255,0.8);
                margin: 0;
                padding: 16px;
            }
        `;
    }

    render() {
        return this.isDisplayed ? html`<div class="spinner"><mc-loading-indicator fit="large" label="Loading vessel track and plans..."></mc-loading-indicator></div>` : html``;
    }

    refreshDisplayState() {
        const selectedVessel = UiStateModel.getValue('imo');
        if (!selectedVessel) {
            this.isDisplayed = false;
            return;
        }

        const vesselActions = ProgressModel.getTargetActions('vessel-' + selectedVessel);
        this.isDisplayed = vesselActions.pending.length > 0;
    }

    firstUpdated() {
        UiStateModel.addEventListener(`${UiStateModelParam.IMO}-change`, this.refreshDisplayState);
        ProgressModel.addEventListener('target-actions-changed', this.refreshDisplayState);

        this.refreshDisplayState();
    }
}
customElements.define('voyage-loading-indicator', VoyageLoadingIndicator);
